import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ADMIN || 'http://localhost:4000/api/admin',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const createAudio = async (formData) => {
  const form = new FormData();
  
  // Append text fields
  form.append('title', formData.title);
  form.append('description', formData.description);
  form.append('genreId', formData.genreId);
  form.append('genreName', formData.genreName); // Add this line to include the genre name
  form.append('language', formData.language);
  form.append('duration', formData.duration);
  form.append('isPublic', formData.isPublic);

  // Add author_id
  if (formData.author_id) {
    form.append('author_id', formData.author_id);
  }

  
  // Append series data if it exists
  if (formData.hasSeries) {
    form.append('hasSeries', formData.hasSeries);
    form.append('seriesId', formData.seriesId);
    form.append('chapterNumber', formData.chapterNumber);
  }

  // Append audio file
  if (formData.audioFile) {
    form.append('audioFile', formData.audioFile);
  }
  
  // Append images if they exist
  if (formData.mobileImage) {
    form.append('mobileImage', formData.mobileImage);
  }
  if (formData.computerImage) {
    form.append('computerImage', formData.computerImage);
  }

  const response = await api.post('/audios', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateAudio = async ({ id, formData }) => {
  // No changes needed to the FormData creation
  
  // Log the formData for debugging (optional)
  console.log('Updating audio with ID:', id);
  
  const response = await api.put(`/audios/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getAudios = async () => {
  const response = await api.get('/audios');
  return response.data;
};

export const getAudioById = async (id) => {
  const response = await api.get(`/audios/${id}`);
  return response.data;
};

export const deleteAudio = async (id) => {
  const response = await api.delete(`/audios/${id}`);
  return response.data;
};

